import { useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Typewriter } from 'react-simple-typewriter'; 
import { FaFacebookF, FaInstagram, FaTiktok, FaLinkedinIn, FaReact, FaHtml5, FaCss3Alt, FaJs, FaWhatsapp } from "react-icons/fa"; 
import { SiFramer } from "react-icons/si";
import "./Hero.css";

export default function Hero() {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  // روابط السوشيال ميديا (تم إضافة الواتساب)
  const socialLinks = [
    { icon: <FaFacebookF />, url: "https://www.facebook.com/share/1Crq4Wnzfu/?mibextid=wwXIfr", color: "#1877F2" },
    { icon: <FaInstagram />, url: "https://www.instagram.com/ziad_hamada_9?igsh=MTZhY3NobTl5a3BueA%3D%3D&utm_source=qr", color: "#E4405F" },
    { icon: <FaTiktok />, url: "https://www.tiktok.com/@ziad_hamada0?_r=1&_t=ZS-95qUW9qo360", color: "#000000" },
    { icon: <FaLinkedinIn />, url: "https://www.linkedin.com/in/ziad-hamada-793046406?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app", color: "#0A66C2" },
    { icon: <FaWhatsapp />, url: "https://wa.me/201204964891", color: "#25D366" },
  ];

  // الأيقونات الطائرة حول الصورة
  const skillsIcons = [
    { icon: <FaReact />, color: "#61DBFB", x: -130, y: -80 },
    { icon: <FaHtml5 />, color: "#E34F26", x: 130, y: -80 },
    { icon: <FaCss3Alt />, color: "#1572B6", x: -140, y: 50 },
    { icon: <FaJs />, color: "#F7DF1E", x: 140, y: 50 },
    { icon: <SiFramer />, color: "#0055FF", x: 0, y: -170 },
  ];

  const iconVariants = {
    hidden: { opacity: 0, x: 0, y: 0, scale: 0 },
    visible: (custom) => ({
      opacity: 1, x: custom.x, y: custom.y, scale: 1,
      transition: { type: "spring", stiffness: 120, damping: 12, delay: 0.05 }
    })
  };

  return (
    <section className="hero">
      <div className="hero-container">
        
        {/* منطقة الصورة والأيقونات */}
        <motion.div 
          className="hero-image-wrapper"
          initial="hidden"
          whileHover="visible"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {skillsIcons.map((skill, index) => (
            <motion.div
              key={index}
              className="floating-skill"
              style={{ color: skill.color }}
              custom={skill}
              variants={iconVariants}
            >
              {skill.icon}
            </motion.div>
          ))}

          <motion.div 
            className="hero-image"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
          >
            <img 
              src={isHovered ? "heroimg2.jpg" : "heroimg.png"} 
              alt="Ziad Hamada" 
              className="main-profile-img"
            />
          </motion.div>
        </motion.div>

        {/* منطقة النصوص */}
        <div className="hero-content">
          <h3>{t('hello')}</h3>
          <h1>{t('name')}</h1>
          
          <h2 className="typewriter-text">
            <Typewriter
              // يجلب المصفوفة من i18n.js (job_titles)
              words={t('job_titles', { returnObjects: true })} 
              loop={0}
              cursor
              cursorStyle='|'
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1500}
            />
          </h2>

          <p>{t('desc')}</p>

          <div className="hero-socials">
            {socialLinks.map((social, index) => (
              <a 
                key={index} 
                href={social.url} 
                target="_blank" 
                rel="noreferrer" 
                className="social-icon" 
                style={{ "--social-color": social.color }}
              >
                {social.icon}
              </a>
            ))}
          </div>

          <div className="hero-buttons">
            <motion.a 
              href="/about" 
              className="btn-primary" 
              whileHover={{ scale: 1.05 }} 
              whileTap={{ scale: 0.95 }}
            >
              {t('btn_about')}
            </motion.a>
          </div>
        </div>
      </div>
    </section>
  );
}